import { createCn } from 'shared-utils'

export const summaryBoxesCn = createCn('summary-boxes')
